import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCrosshair, FiInstagram, FiTwitter, FiFacebook, FiArrowRight } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-zinc-400 pt-24 pb-12 overflow-hidden border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-16 mb-24">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 text-white mb-8">
              <SafeIcon icon={FiCrosshair} className="text-3xl text-red-600" />
              <span className="font-black text-2xl tracking-tighter">FORGE & FORK</span>
            </div>
            <p className="text-lg text-zinc-500 mb-10 max-w-md leading-relaxed">
              We believe the right tools transform cooking from a chore into an art form. Our equipment is chosen for its performance, durability, and ergonomic design.
            </p>
            <div className="flex gap-6">
              {[FiInstagram, FiTwitter, FiFacebook].map((Icon, idx) => (
                <a key={idx} href="#" className="w-12 h-12 rounded-full border border-zinc-800 flex items-center justify-center text-white hover:bg-red-600 hover:border-red-600 transition-all duration-300">
                  <SafeIcon icon={Icon} className="text-xl" />
                </a>
              ))}
            </div>
          </div>
          
          <div className="lg:col-span-2">
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">Navigation</h4>
            <ul className="space-y-4 text-sm font-bold">
              {['Shop All', 'Knife Sets', 'Cookware', 'Prep Tools', 'Gift Cards'].map(item => (
                <li key={item}><a href="#" className="hover:text-red-500 transition-colors uppercase tracking-widest">{item}</a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">Company</h4>
            <ul className="space-y-4 text-sm font-bold">
              {['About Us', 'Sustainability', 'Bulk Orders', 'Careers', 'Contact'].map(item => (
                <li key={item}><a href="#" className="hover:text-red-500 transition-colors uppercase tracking-widest">{item}</a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">STAY SHARP</h4>
            <p className="text-sm text-zinc-500 mb-6 leading-relaxed">Join 50k+ chefs for weekly recipes and tool tips.</p>
            <form className="relative">
              <input 
                type="email" 
                placeholder="Email address" 
                className="w-full bg-zinc-900 border border-zinc-800 text-white px-6 py-4 rounded-none focus:outline-none focus:border-red-600 transition-colors font-bold uppercase text-xs tracking-widest"
              />
              <button className="absolute right-2 top-2 bottom-2 bg-red-600 text-white px-4 hover:bg-red-700 transition-colors">
                <SafeIcon icon={FiArrowRight} />
              </button>
            </form>
          </div>
        </div>

        <div className="pt-12 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-black uppercase tracking-[0.2em]">
          <div className="flex flex-wrap justify-center gap-8">
            <p>&copy; {new Date().getFullYear()} Forge & Fork Global Ltd.</p>
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
          <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
}